import React from "react"
import styled from "styled-components"

interface Props {
  message: string
  onConfirm: () => void
  onCancel: () => void
}

const ConfirmationModalContent: React.FC<Props> = ({
  message,
  onConfirm,
  onCancel,
}) => {
  return (
    <ModalContentContainer>
      <Message>{message || "Are you sure?"}</Message>
      <ButtonContainer>
        <CancelButton onClick={onCancel} className="btn btn-secondary">Cancel</CancelButton>
        <ConfirmButton onClick={onConfirm} className="btn btn-danger">Confirm</ConfirmButton>
      </ButtonContainer>
    </ModalContentContainer>
  )
}

export default ConfirmationModalContent

const ModalContentContainer = styled.div`
  padding: 4rem 2rem;
  text-align: center;
  max-width: 500px;
`

const Message = styled.p`
  color: white;
  margin-bottom: 20px;
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
`

const Button = styled.button`
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
`

const ConfirmButton = styled(Button)`
`

const CancelButton = styled(Button)`
`
